<template>
  <v-container :fluid="fluid" class="layout-content py-15">
    <slot />
  </v-container>
</template>

<script>
export default {
  props: ['fluid']
}
</script>

<style lang="scss" scoped>
.layout-content {
  min-height: 80vh;
}
</style>
